import React, {ReactNode} from "react";
import {useAuth} from "../context/AuthContext";
import {Navigate} from "react-router-dom";
import {LoadingPageView} from "../../../common/components/LoadingPageView";

interface ProtectedRouteProps {
    children: ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {

    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return (
            <LoadingPageView/>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};